import { Skeleton } from '@/new/components/shadcn/skeleton';

export const SummaryLoader = () => (
  <div className="space-y-8">
    <div className="rounded-md border-2 border-gray-200/60 bg-white p-4">
      <Skeleton className="mb-2 h-6 w-24" />
      <Skeleton className="mb-2 h-4 w-full" />
      <Skeleton className="mb-2 h-4 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
    </div>

    <div className="flex w-full justify-between gap-8">
      <div className="w-1/2 rounded-md border-2 border-gray-200/60 bg-white p-4">
        <Skeleton className="mb-4 h-6 w-32" />
        <Skeleton className="mb-2 h-4 w-full" />
        <Skeleton className="mb-2 h-4 w-3/4" />
      </div>
      <div className="w-1/2 rounded-md border-2 border-gray-200/60 bg-white p-4">
        <Skeleton className="mb-4 h-6 w-32" />
        <Skeleton className="mb-2 h-4 w-full" />
        <Skeleton className="mb-2 h-4 w-3/4" />
      </div>
    </div>

    <div className="rounded-md border-2 border-gray-200/60 bg-white p-4">
      <Skeleton className="mb-4 h-6 w-32" />
      <div className="space-y-2">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
    </div>
  </div>
);
